import React from "react";
import SEO from "@/components/SEO";
import PageHeader from "@/components/PageHeader";
import FinalCTA from "@/components/FinalCTA";
import { MessageSquare, Wallet, Receipt, KeyRound, Globe2, Repeat2, Plug, Smartphone, Mail } from "lucide-react";
import { useT } from "@/hooks/useT";

export default function Integrimet() {
  const t = useT();
  const GROUPS = [
    {
      name: t("Komunikimi me klientin","Guest communication"),
      items: [
        [MessageSquare, "WhatsApp Business",         t("Konfirmime, kujtues check-in, mesazhe automatike","Confirmations, check-in reminders, auto messages")],
        [Mail,          t("Email i automatizuar","Automated email"), t("Para mbërritjes, pas qëndrimit, fushata","Pre-arrival, post-stay, campaigns")],
        [Smartphone,    "SMS",                         t("Kode dhe konfirmime","Codes and confirmations")],
      ],
    },
    {
      name: t("Pagesat dhe Sistemi Fiskal","Payments & Fiscal System"),
      items: [
        [Wallet,  "Stripe / PayPal",                    t("Pagesa online të sigurta","Secure online payments")],
        [Receipt, t("Sistemi fiskal","Fiscal system"),   t("Lidhje me fiskalizimin shqiptar","Connected to Albanian fiscalization")],
        [Wallet,  t("Kartëlexues","Card readers"),        t("Lidhje me terminale POS","Connected to POS terminals")],
      ],
    },
    {
      name: t("Çelësat dhe Operacionet","Keys & Operations"),
      items: [
        [KeyRound, t("Çelësa smart","Smart keys"),        t("Akses pa çelës fizik për klientët","Keyless entry for guests")],
        [Plug,     t("API e hapur","Open API"),           t("Webhook dhe REST për integrime","Webhook and REST for integrations")],
        [Repeat2,  t("Integrime API","API integrations"), t("Lidhje me kanalet e tjera përmes API","Connect other channels via API")],
      ],
    },
    {
      name: t("Kanalet e Rezervimit","Booking Channels"),
      items: [
        [Globe2, "Booking.com",       t("Lidhje direkte 2-drejtimsh","Direct two-way sync")],
        [Globe2, "Airbnb",             t("Rezervimet hyjnë vetë","Bookings flow in automatically")],
        [Globe2, "Expedia / Agoda",   t("Çmime dhe rezervime të përditësuara","Live rates and reservations")],
      ],
    },
  ];
  return (
    <>
      <SEO
        title={t("Integrime — WhatsApp, Pagesa, Çelësa Smart, Kanale Rezervimi","Integrations — WhatsApp, Payments, Smart Keys, Booking Channels")}
        description={t(
          "Akomoda lidhet me WhatsApp, email, SMS, pagesat online, sistemin fiskal shqiptar, çelësat smart dhe me Booking.com, Airbnb e Expedia.",
          "Akomoda connects to WhatsApp, email, SMS, online payments, the Albanian fiscal system, smart keys, and Booking.com, Airbnb and Expedia."
        )}
      />
      <PageHeader
        eyebrow={t("Integrimet","Integrations")}
        title={t("I lidhur me mjetet që përdorni çdo ditë","Connected to the tools you use every day")}
        description={t(
          "Akomoda nuk është një sistem më vete. Lidhet me sistemet e pagesës, sistemin fiskal, mesazherinë dhe kanalet kryesore të rezervimit.",
          "Akomoda isn't a walled garden. It plugs into payment systems, the fiscal system, messaging tools and the major booking channels."
        )}
        ctas={[
          { to: "/demo",    label: t("Kërko Demo","Request Demo") },
          { to: "/kontakt", label: t("Pyetni për një integrim","Ask about an integration"), variant: "ghost" },
        ]}
        breadcrumb={[{ label: t("Integrimet","Integrations") }]}
      />
      <section className="bg-surface-1">
        <div className="container-akm space-y-10 py-14 md:py-20">
          {GROUPS.map((g) => (
            <div key={g.name}>
              <div className="mb-4 flex items-end justify-between">
                <h2 className="font-display text-xl font-bold text-ink">{g.name}</h2>
                <span className="text-xs text-slate2">{g.items.length} {t("integrime","integrations")}</span>
              </div>
              <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
                {g.items.map(([Icon, tt, d]) => (
                  <div key={tt} className="card-akm">
                    <span className="grid h-9 w-9 place-items-center rounded-md border border-line bg-bg text-[#FF7A00]">
                      <Icon size={16} />
                    </span>
                    <div className="mt-3 font-display text-base font-bold text-ink">{tt}</div>
                    <div className="text-sm text-slate2">{d}</div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </section>
      <FinalCTA />
    </>
  );
}
